import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';

export interface IResource {
  id: string;
  label: string;
  uri: string;
  type: string;
  ownerStudioId: string;
  description: string;
  isGlobal: boolean;
  favorite: boolean;
  manufacturerId?: string;
  manufacturerName?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IResourceApiModel {
  id: string;
  label: string;
  uri: string;
  type: string;
  ownerStudioId: string;
  description: string;
  isGlobal: boolean;
  resourceStudios?: Array<{ favorite: boolean }>;
  resourceManufacturers?: Array<{ id: string; manufacturer: { name: string } }>;
  resourceProducts?: Array<{ product: { manufacturer: { name: string } } }>;
  createdAt: string;
  updatedAt: string;
}

export default class Resource implements IResource {
  public readonly id: string;

  public readonly label: string;

  public readonly uri: string;

  public readonly type: string;

  public readonly ownerStudioId: string;

  public readonly description: string;

  public readonly isGlobal: boolean;

  public readonly favorite: boolean;

  public readonly manufacturerId?: string;

  public readonly manufacturerName?: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    label: string,
    uri: string,
    type: string,
    ownerStudioId: string,
    description: string,
    isGlobal: boolean,
    favorite: boolean,
    createdAt: Date,
    updatedAt: Date,
    manufacturerId?: string,
    manufacturerName?: string,
  ) {
    this.id = id;
    this.label = label;
    this.uri = uri;
    this.type = type;
    this.ownerStudioId = ownerStudioId;
    this.description = description;
    this.isGlobal = isGlobal;
    this.favorite = favorite;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.manufacturerId = manufacturerId;
    this.manufacturerName = manufacturerName;
  }

  static fromApiModel(apiModel: IResourceApiModel) {
    const {
      id,
      label,
      type,
      ownerStudioId,
      description,
      isGlobal,
      resourceStudios,
      resourceManufacturers,
      resourceProducts,
    } = apiModel;

    const favorite = resourceStudios?.[0]?.favorite || false;
    const manufacturerId = resourceManufacturers?.[0]?.id;
    const manufacturerName =
      resourceManufacturers?.[0]?.manufacturer?.name ||
      resourceProducts?.[0]?.product?.manufacturer?.name;

    const uri = updateBeamUrl(apiModel.uri);
    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new Resource(
      id,
      label,
      uri,
      type,
      ownerStudioId,
      description,
      isGlobal,
      favorite,
      createdAt,
      updatedAt,
      manufacturerId,
      manufacturerName,
    );
  }

  static arrayFromApiModel(arrayApiModel: IResourceApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
